import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticTemplateComponent } from '../static';
import { HeadingComponent } from '../views/heading/heading';
import { FooterComponent } from '../views/footer/footer';
import { SharedTemplateModule } from '~/templates/shared/modules/sharedTemplateModule';
import { SharedModule } from '~/modules/sharedModule';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        SharedTemplateModule
    ],
    declarations: [
        StaticTemplateComponent,
        HeadingComponent,
        FooterComponent
    ],
    exports: [
        CommonModule,
        SharedModule,
        SharedTemplateModule,
        StaticTemplateComponent,
        HeadingComponent,
        FooterComponent
    ]
})

export class StaticTemplateModule {
}